import { z } from 'zod'
import { Model } from './architecture'
import { Languages } from '@s4l/i18n/types/Languages'

export const I18nTextValidation = z.object({
  value: z.record(z.enum(Languages).or(z.literal('default')), z.string()).or(z.string()),
})
export class I18nText extends Model {
  static create({ value }: z.infer<typeof I18nTextValidation>) {
    I18nTextValidation.parse({ value })
    return new I18nText(value)
  }

  constructor(
    private readonly _value:
      | Partial<Record<Languages | 'default', string>>
      | { default: string }
      | string
  ) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  isAKey(value: unknown): value is string {
    return typeof value === 'string'
  }

  getText(language?: Languages) {
    const text = this.value

    if (this.isAKey(text)) {
      return {
        text,
        translated: false,
      }
    }

    if (!language) {
      return {
        text: text.default,
        translated: true,
      }
    }

    return {
      text: text[language as keyof typeof this.value] || text.default,
      translated: true,
    }
  }

  toJSON() {
    return { value: this.value }
  }
}
